import { formatISO, isFuture, parseISO } from 'date-fns'
import { object, string } from 'yup'

const DiscretionaryCommissionSchema = object().shape({
  full_name: string()
    .required('Full name is required')
    .matches(
      /^[A-Za-z-.,'` ]{1,255}$/,
      'Full name can only contain letters and basic punctuation',
    )
    .min(2, 'Full name must be at least 2 characters')
    .max(255, 'Full name must be at most 255 characters')
    .trim(),
  email: string()
    .required('Email is required')
    .matches(
      /^([a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*)@([a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,})$/,
      'Email must be a valid email address',
    )
    .max(255)
    .trim(),
  tel: string()
    .required('Phone is required')
    .matches(/^\d{7,11}$/, {
      message: 'Please enter a valid telephone number',
      excludeEmptyString: true,
    })
    .trim(),
  dob: string()
    .required('Please enter your date of birth')
    .transform((value) => {
      if (value) {
        const parts = value.split('/')
        const formattedDate = new Date(parts[2], parts[1] - 1, parts[0])
        return formatISO(formattedDate, { representation: 'date' })
      }
      return value
    })
    .test(
      'is-future',
      'Date of birth cannot be in the future',
      (value) => !value || !isFuture(parseISO(value)),
    ),
  address_line1: string().required('Address Line 1 is required').trim(),
  address_line2: string().trim(),
  town: string().required('Town is required').trim(),
  county: string().trim(),
  postcode: string()
    .required('Postcode is required')
    .trim()
    .matches(
      /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/,
      'Postcode must be a valid UK postcode',
    ),
  same_address: string().required(),
  prev_address_line1: string().when('same_address', {
    is: (value) => value === 'false',
    then: (rule) => rule.trim().required('Previous Address Line 1 is required'),
  }),
  prev_address_line2: string().trim(),
  prev_town: string().when('same_address', {
    is: (value) => value === 'false',
    then: (rule) => rule.trim().required('Previous Town is required'),
  }),
  prev_county: string().trim(),
  prev_postcode: string().when('same_address', {
    is: (value) => value === 'false',
    then: (rule) =>
      rule
        .required('Previous Postcode is required')
        .trim()
        .matches(
          /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[\s]?[0-9][A-Za-z]{2}|(E|N|W|S|NW|SE|SW|EC|WC)[0-9Rr][0-9A-Za-z]?[\s]?[0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2})$/,
          'Postcode must be a valid UK postcode',
        ),
  }),
  reg_num: string().required('Vehicle registration number is required').trim(),
  vehicle: string()
    .required('Make and model of the vehicle is required')
    .trim(),
  bought: string()
    .transform((value) => {
      if (value) {
        const parts = value.split('/')
        const formattedDate = new Date(parts[2], parts[1] - 1, parts[0])
        return formatISO(formattedDate, { representation: 'date' })
      }
      return value
    })
    .test(
      'is-future',
      'Purchase date cannot be in the future',
      (value) => !value || !isFuture(parseISO(value)),
    ),
  agreement_or_reg_num: string().trim(),
  dealer: string().trim(),
  enquiry_type: string()
    .required('Please select whether you are making an enquiry or complaint')
    .oneOf(
      ['enquiry', 'complaint'],
      'Please select whether you are making an enquiry or complaint',
    ),
})

export default DiscretionaryCommissionSchema
